import { createContext, useContext } from 'react'
import type { User } from '@supabase/supabase-js'
import type { Database } from '../types/supabase'

export type Profile = Database['public']['Tables']['profiles']['Row']
export type Membership = Database['public']['Tables']['memberships']['Row'] & {
  org_name?: string
}

export interface AuthUser extends User {
  profile?: Profile
  memberships?: Membership[]
}

interface AuthContextType {
  user: AuthUser | null
  login: (email: string, password: string) => Promise<void>
  register: (name: string, email: string, password: string, phone: string) => Promise<void>
  updateProfile: (updates: Partial<Profile>) => Promise<void>
  logout: () => Promise<void>
  isLoading: boolean
  resetSessionTimeout: () => void
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
